export default {
  path: "/HighlightedTopic/PrivatePropertyCrashes",
  name: "Highlighted Topic - Private Property",
  type: "highlightedTopic",
  htmlContent: "HT-PrivatePropertyCrashes.html",
  keyPoints: [
    "Private Property crashes with an injury/death should have full crash form completed whereas a PDO crash can have fewer details.  ",
    "Private property crashes will start on private property, end on private property, and all damage sustained will occur on private property. ",
  ],
  scenarios: [
    {
      name: "Private Property Crash Scenario 1",
      description:
        "<p>Unit 1 is parked at an incline in a driveway on residential property. Unit 1 rolls down the driveway, travels across the roadway, and crosses a yard. Unit 1 comes to a stop as it strikes the house across the street. The Crash Report should be marked as <strong>Private Property </strong>because even though Unit 1 crossed the roadway, the <strong>crash started on Private Property, ended on Private Property, and all damage occurred on Private Property. </strong>The <u>Location at Area of Impact</u> should be coded as “16-Private Property” and the <u>Traffic-Way Flow</u> should be coded “7-Private Roadway / Driveway”.</p>",
      image:
        "https://crashmanual.s3.us-east-2.amazonaws.com/Scenarios/PrivateProperty/PrivateProperty1.png",
    },
    {
      name: "Private Property Crash Scenario 2",
      description:
        "<p><span>Unit 1 is stopped behind other cars in a shopping market driveway waiting to pull out into a roadway. Unit 2 crashes into the rear end of Unit 1. Both vehicles remain in the driveway of the shopping center. If 100% of the vehicles involved are within the driveway, <strong>t</strong></span><span><strong>his is a Private Property crash. </strong></span><span>The <u>Location at Area<strong> </strong>of Impact</u> should be coded as “16-Private Property” and the <u>Traffic-Way Flow</u> should be coded “7-Private Roadway / Driveway”.</span></p>",
      image:
        "https://crashmanual.s3.us-east-2.amazonaws.com/Scenarios/PrivateProperty/PrivateProperty2.png",
    },
    {
      name: "Private Property Crash Scenario 3",
      description:
        "<p><span>Unit 1 is backing out of a parking space at a convenience store. Unit 1 crashes into Unit 2 that is parked in an adjacent parking space. </span><span><strong>This is a Private Property crash.</strong></span><span> The <u>Location at Area of Impact</u> should be coded as “16-Private Property” and the <u>Traffic-Way Flow</u> should be coded “6-Parking Lot”.</span></p>",
      image:
        "https://crashmanual.s3.us-east-2.amazonaws.com/Scenarios/PrivateProperty/PrivateProperty3.png",
    },
    {
      name: "Non-Private Property Crash Scenario 1",
      description:
        "<p><span>Unit 1 was backing out of a driveway on to a roadway when it struck Unit 2. Unit 2 was on a public roadway; the crash is <strong>NOT a Private Property Crash</strong>.</span><span> The <u>Location at Area of Impact</u> should be coded as “9-On Roadway - Driveway Intersection”.</span></p>",
      image:
        "https://crashmanual.s3.us-east-2.amazonaws.com/Scenarios/PrivateProperty/PrivateProperty4.png",
    },
    {
      name: "Non-Private Property Crash Scenario 2",
      description:
        "<p>Unit 1 was driving on the roadway behind Unit 3, a non-contact vehicle. Unit 3 had stopped in traffic and Unit 1 took faulty evasive action striking Unit 2, which was parked in a gas station parking lot. <span>This is a public roadway crash, <strong>NOT a Private Property crash</strong>. The crash began on a public roadway and the First Harmful Event was the attempt to avoid Unit 3, this caused the driver to leave the roadway and collide with a parked vehicle on private property.</span><span> The <u>Location at Area of Impact</u> should be coded as “3-Off Roadway”.</span></p>",
      image:
        "https://crashmanual.s3.us-east-2.amazonaws.com/Scenarios/PrivateProperty/PrivateProperty5.png",
    },
    {
      name: "Non-Private Property Crash Scenario 3",
      description:
        "<p>Unit 1 was traveling south on Kings Highway. As the southbound lane began to change into a slight right curve, Unit 1 traveled off the roadway to the left and struck a mailbox. After striking the mailbox, Unit 1 continued southbound in a yard and struck a small metal utility box, traveled across Sumter Drive before striking a guy wire and the corner of a house. The <u>Location at Area of Impact</u> should be coded as “3-Off Roadway”, the <u>First Harmful Event</u> may be coded as “39-Roadway/Lane Departure – Left”.</p>",
      image:
        "https://crashmanual.s3.us-east-2.amazonaws.com/Scenarios/PrivateProperty/PrivateProperty6.png",
    },
  ],
  keywords: [
    "private",
    "property",
    "driveway",
    "parking lot",
    "gated",
    "house",
    "parked",
    "building",
  ],
};
